export const updateCurrentPageInHtml = (newPage: number, listWrapperRootElement: HTMLElement) => {
    const currentPageElement = listWrapperRootElement.querySelector<HTMLSpanElement>('.cr_list-wrapper__pagination-current-page');
    if (currentPageElement) {
        currentPageElement.innerText = newPage.toString();
    }
};
